import { FC } from 'react';
import { Box, AnimatedShape } from '@altermaind/web/ui';

type Props = {
  hasTitle?: boolean;
  hasOnChangeFuncionality?: boolean;
  hasFilterFuncionality?: boolean;
  hasAddFuncionality?: boolean;
};

export const HeaderTableSkeleton: FC<Props> = ({
  hasTitle,
  hasOnChangeFuncionality,
  hasFilterFuncionality,
  hasAddFuncionality,
}) => {
  return (
    <Box display='flex' flexDirection='column'>
      <Box display='flex' justifyContent='space-between' width='100%' flexDirection='column'>
        <Box alignItems='center' justifyContent='space-between' mb='l' display='flex'>
          <Box alignItems='flex-start' flex={1}>
            {hasTitle && <AnimatedShape height={25} width='90%' />}
          </Box>

          <Box display='flex' flexDirection='row' justifyContent='flex-end' flex={1}>
            {hasOnChangeFuncionality && <AnimatedShape width={200} height={45} variant='round' />}
            {hasFilterFuncionality && (
              <AnimatedShape width={100} height={45} variant='round' ml='xs' />
            )}
            {hasAddFuncionality && (
              <AnimatedShape width={100} height={45} variant='round' ml='xs' />
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
